import React from 'react';
import PropTypes from 'prop-types';
import { Figure, SocialButton } from '../styles/styled_blogpost';

const SocialMedia = ({ url, title }) => {
  return (
    <>
      <Figure
        className="social links figure"
        style={{
          WebkitBoxOrient: 'horizontal',
          WebkitBoxDirection: 'normal',
          WebkitBoxPack: 'center',
          WebkitBoxAlign: 'center',
          MsFlexDirection: 'row',
          MsFlexWrap: 'wrap',
          MsFlexPack: 'center',
          MsFlexLinePack: 'center',
          MsFlexAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          padding: '0.83333em',
          marginTop: '15px',
        }}
      >
        <SocialButton
          tabIndex="0"
          className="SocialMediaShareButton SocialMediaShareButton--twitter"
          href={`https://twitter.com/intent/tweet?text=${title}&url=${url}&utm_source=blog&utm_medium=twitter&utm_campaign=share`}
          target="_blank"
          aria-label="Share to twitter"
          rel="noopener"
        >
          <div style={{ width: '48px', height: '48px' }}>
            <svg
              viewBox="0 0 64 64"
              fill="white"
              width="48"
              height="48"
              className="social-icon social-icon--twitter "
            >
              <g>
                <circle cx="32" cy="32" r="31" fill="#00aced"></circle>
              </g>
              <g>
                <path d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"></path>
              </g>
            </svg>
          </div>
        </SocialButton>
        <SocialButton
          tabIndex="0"
          className="SocialMediaShareButton SocialMediaShareButton--facebook"
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}&utm_source=blog&utm_medium=facebook&utm_campaign=share`}
          target="_blank"
          aria-label="Share to facebook"
          rel="noopener"
        >
          <div style={{ width: '48px', height: '48px' }}>
            <svg
              viewBox="0 0 64 64"
              fill="white"
              width="48"
              height="48"
              className="social-icon social-icon--facebook "
            >
              <g>
                <circle cx="32" cy="32" r="31" fill="#3b5998"></circle>
              </g>
              <g>
                <path d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"></path>
              </g>
            </svg>
          </div>

          <div className="SocialMediaShareCount">
            <div className="share-count" style={{ textAlign: 'center' }}></div>
          </div>
        </SocialButton>

        {/* TODO: enable linked share button and add whatsapp share button */}
        {/* <SocialButton
          role="button"
          tabIndex="0"
          className="SocialMediaShareButton SocialMediaShareButton--linkedin"
        >
          <div style={{ width: '48px', height: '48px' }}>
            <svg
              viewBox="0 0 64 64"
              fill="white"
              width="48"
              height="48"
              className="social-icon social-icon--linkedin "
            >
              <g>
                <circle cx="32" cy="32" r="31" fill="#007fb1"></circle>
              </g>
              <g>
                <path d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"></path>
              </g>
            </svg>
          </div>

          <div className="SocialMediaShareCount">
            <div className="share-count" style={{ textAlign: 'center' }}></div>
          </div>
        </SocialButton> */}
        <SocialButton
          tabIndex="0"
          className="SocialMediaShareButton SocialMediaShareButton--telegram"
          href={`https://telegram.me/share/url?url=${url}&text=${title}&utm_source=blog&utm_medium=telegram&utm_campaign=share`}
          target="_blank"
          aria-label="Share to telegram"
          rel="noopener"
        >
          <div style={{ width: '48px', height: '48px' }}>
            <svg
              viewBox="0 0 64 64"
              fill="white"
              width="48"
              height="48"
              className="social-icon social-icon--telegram "
            >
              <g>
                <circle cx="32" cy="32" r="31" fill="#37aee2"></circle>
              </g>
              <g>
                <path d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"></path>
              </g>
            </svg>
          </div>
        </SocialButton>
      </Figure>
    </>
  );
};

export default SocialMedia;

SocialMedia.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
